export default "__VITE_ASSET__Ck69o2SA__"